import * as util from './util';
import CONST from './const';
import logger from './logger';
import fileUtil from './fileUtil';
import encryptUtil from './encryptUtil';
import * as workerManager from './workerManager';

class DefaultWorker {
  constructor(encryptor, opt = {}) {
    this._encryptor = encryptor;
    this._opt = opt;
    this._taskId = Date.now() + Math.floor(Math.random() * 10000);
  }

  append(data) {
    try {
      this._encryptor.append(data);
    } catch (e) {
      this._opt.onError &&
        this._opt.onError({
          ret: CONST.REPORT.ENCRYPT_APPEND_ERROR,
          message: e.message || 'encrypt append error',
          info: e,
        });
    }
  }

  end() {
    let result;

    try {
      result = this._encryptor.end();
    } catch (e) {
      this._opt.onError &&
        this._opt.onError({
          ret: CONST.REPORT.ENCRYPT_END_ERROR,
          message: e.message || 'encrypt end error',
          info: e,
        });
    }

    if (result) {
      this._opt.onResult && this._opt.onResult(result);
    }

    return result;
  }
}

// 算hash
const encrypt = (file, opt = {}) => {
  const startTime = Date.now();
  const type = opt.type === 'sha' ? 'sha' : 'md5';
  let wasm = false;

  if (type === 'sha' && util.supportWasm()) {
    wasm = true;
    logger.log('[encrypt] use sha-wasm');
    encryptByDefaultWorker(type, wasm, file, opt);
    return;
  }

  workerManager
    .work(file, type)
    .done(str => {
      opt.onResult && opt.onResult(str);

      let costTime = Date.now() - startTime;
      console.log('------', file);

      logger.log('[encrypt] cal hash cost ' + costTime + ', file size ' + file.size);

      util.report007('ENCRYPT_WORKER_DONE', 0, 0, costTime);
    })
    .fail(err => {
      // 不是不支持导致的错误，上报一下
      if (err.ret !== CONST.REPORT.NOT_SUPPORT_WEBWORKER) {
        logger.log('[encrypt] get encrypt worker error');

        util.report007('ENCRYPT_WORKER_DONE', 1, err.ret, Date.now() - startTime);
      }

      logger.log('[encrypt] cal hash by current web, file size ' + file.size);

      encryptByDefaultWorker(type, wasm, file, opt);
    });
};

const encryptByDefaultWorker = (type, wasm, file, opt = {}) => {
  const startTime = Date.now();

  const encryptor = encryptUtil.getEncryptor(`${type}${wasm ? '-wasm' : ''}`);
  const worker = new DefaultWorker(encryptor, {
    onResult(str) {
      opt.onResult && opt.onResult(str);
      console.log('------', file);

      let costTime = Date.now() - startTime;

      logger.log('[encrypt] cal hash cost ' + costTime + ', file size ' + file.size);

      util.report007(
        `ENCRYPT_${wasm ? 'WASM' : 'NORMAL'}_DONE_${util.getEncryptChunkSize}`,
        0,
        0,
        costTime,
      );
    },
    onError(err = {}) {
      opt.onError && opt.onError(err);

      let costTime = Date.now() - startTime;

      logger.log('[encrypt] get encrypt worker error');

      util.report007(
        `ENCRYPT_${wasm ? 'WASM' : 'NORMAL'}_DONE_${util.getEncryptChunkSize}`,
        1,
        err.ret,
        costTime,
      );
    },
  });

  fileUtil.readFileByStep(file, {
    type: encryptor.readType,
    fragment: util.getEncryptChunkSize * 1024,
    onStep(data, percent) {
      worker.append(data);

      opt.onProgress && opt.onProgress(percent);
    },
    onEnd() {
      worker.end();
    },
    onFail(err) {
      const costTime = Date.now() - startTime;

      logger.log('[encrypt] read file error');

      opt.onError && opt.onError(err);

      util.report007(
        `ENCRYPT_NORMAL_DONE_${util.getEncryptChunkSize}`,
        1,
        CONST.MD.ENCRYPT_READFILE_ERROR,
        costTime,
      );
    },
  });
};

export default {
  encrypt,
};
